import React from "react";
import { Button } from "@mui/material";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import styles from "@/src/styles/home.module.css";

function GetStartedSection(props: { title?: string }) {
  return (
    <Box sx={{ py: 0, padding: "60px 0 0" }}>
      <Container maxWidth={false} className={"containerWidth"}>
        <div className={styles.getStartedBox}>
          <h1 className={styles.sendResultTitle}>Header</h1>
          <div className={styles.sendResultText}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
            <br /> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
          </div>
          <div className={styles.sendResultButton}>
            <Button
              variant="contained"
              sx={{
                width: "180px",
                height: "50px",
                boxShadow: "none",
                backgroundColor: "#fff",
                color: "#3f3f3f",
                fontSize: "15px",
                fontWeight: 600,
                borderRadius: "8px",
                textTransform: "none",
                "&.MuiButtonBase-root:hover": {
                  backgroundColor: "#eee",
                },
              }}
            >
              CTA 1
            </Button>

            <Button
              variant="contained"
              sx={{
                width: "190px",
                height: "50px",
                boxShadow: "none",
                backgroundColor: "#fff",
                color: "#3f3f3f",
                fontSize: "15px",
                fontWeight: 600,
                borderRadius: "8px",
                textTransform: "none",
                "&.MuiButtonBase-root:hover": {
                  backgroundColor: "#eee",
                },
              }}
            >
              CTA 2
            </Button>
          </div>
        </div>
      </Container>
    </Box>
  );
}

export default GetStartedSection;
